import "core-js/modules/es.array.push.js";
export default {
  state: {
    questions: []
  },
  mutations: {
    ADD_QUESTION: function ADD_QUESTION(state, data) {
      state.questions.push(data);
    }
  },
  actions: {
    addQuestion: function addQuestion(_ref, data) {
      var commit = _ref.commit;
      commit('ADD_QUESTION', data);
    }
  }
};